import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import {VueJsonp} from 'vue-jsonp'
import {
  createMap ,
  deepClone,
  sleep
} from './utils/index';
import {$math} from './utils/math';



import './utils/flexible'
import './utils/globalHandle'
import 'vant/lib/index.css';

Vue.prototype.createMap = createMap;
Vue.prototype.deepClone = deepClone;
Vue.prototype.$sleep = sleep;
Vue.prototype.$math = $math;




Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueJsonp);

Vue.prototype.$axios = axios;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
